import React, { useState } from "react";
import {
  FaArrowUp, FaArrowDown, FaArrowLeft, FaArrowRight,
  FaSearchPlus, FaSearchMinus
} from "react-icons/fa";
import PTZDirectionIndicator from "./PTZDirectionIndicator";
import "./PTZPanel.css";
import { authFetch } from "../../utils";

const PTZPanel = ({ cameraId }) => {
  const cameraGatewayApiUrl = "https://camgateway.senticnel.com/ptz";
  const [preset, setPreset] = useState(1);

  const sendCommand = async (endpoint, body = {}) => {
    try {
      await authFetch(`${cameraGatewayApiUrl}${endpoint}/${cameraId}`, {
        method: "POST",
        body: JSON.stringify(body),
      });
    } catch (err) {
      console.error("Error enviando comando PTZ:", err);
    }
  };

  return (
    <div className="ptz-container">
      <button
        className="ptz-button"
        onMouseDown={() => sendCommand("/move", { direction: "Up" })}
        onMouseUp={() => sendCommand("/stop", { direction: "Up" })}
      >
        <FaArrowUp />
      </button>

      <div className="ptz-row">
        <button
          className="ptz-button"
          onMouseDown={() => sendCommand("/move", { direction: "Left" })}
          onMouseUp={() => sendCommand("/stop", { direction: "Left" })}
        >
          <FaArrowLeft />
        </button>
        <button
          className="ptz-button"
          onMouseDown={() => sendCommand("/move", { direction: "Right" })}
          onMouseUp={() => sendCommand("/stop", { direction: "Right" })}
        >
          <FaArrowRight />
        </button>
      </div>

      <button
        className="ptz-button"
        onMouseDown={() => sendCommand("/move", { direction: "Down" })}
        onMouseUp={() => sendCommand("/stop", { direction: "Down" })}
      >
        <FaArrowDown />
      </button>

      <div className="ptz-row">
        <button
          className="ptz-button"
          onMouseDown={() => sendCommand("/move", { direction: "ZoomTele" })}
          onMouseUp={() => sendCommand("/stop", { direction: "ZoomTele" })}
        >
          <FaSearchPlus />
        </button>
        <button
          className="ptz-button"
          onMouseDown={() => sendCommand("/move", { direction: "ZoomWide" })}
          onMouseUp={() => sendCommand("/stop", { direction: "ZoomWide" })}
        >
          <FaSearchMinus />
        </button>
      </div>

      <div className="ptz-presets">
        Preset
        <select
          className="ptz-select"
          value={preset}
          onChange={(e) => setPreset(Number(e.target.value))}
        >
          {Array.from({ length: 12 }, (_, i) => i + 1).map(num => (
            <option key={num} value={num}>{num}</option>
          ))}
        </select>
        <button
          className="ptz-button"
          onClick={() => sendCommand("/preset", { preset })}
        >
          Ir
        </button>
      </div>

      <div style={{ marginTop: "20px" }}>
        <PTZDirectionIndicator cameraId={cameraId} />
      </div>
    </div>
  );
};

export default PTZPanel;
